import gql from "graphql-tag";
import { accommodationFragment } from '@/graphql/accommodation/accommodationFragments'

export const UPSERTACCOMMODATION = gql`
    mutation upsertAccommodation(
        $id: ID
        $name: String
        $primary_phone: String
        $email: String
        $secondary_phone: String
        $fax: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $website: String
        $note: String
        $internal_notes: String
    ){
        upsertAccommodation(
            input: {
                id: $id
                name: $name
                primary_phone: $primary_phone
                email: $email
                secondary_phone: $secondary_phone
                fax: $fax
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                website: $website
                note: $note
                internal_notes: $internal_notes
            }
        ){
            ...accommodationFragment
        }
    }
    ${accommodationFragment}
`;

export const DELETEACCOMMODATION = gql`
    mutation deleteAccommodation(
        $id: ID!
    ){
        deleteAccommodation(
            id: $id
        ){
            ...accommodationFragment
        }
    }
    ${accommodationFragment}
`



export const RESTOREREACCOMMODATION = gql`
    mutation restoreAccommodation(
        $id: ID!
    ){
        restoreAccommodation(
            id: $id
        ){
            ...accommodationFragment
        }
    }
    ${accommodationFragment}
`
